import { DevicePreviewEnum } from '@lighthouse/core'
import React, { useMemo } from 'react'

import { getDeviceTypeFromCache } from '../../utils'
import { MobileAccountLayout } from './mobile'
import type { AccountLayoutProps } from './types'
import { WebAccountLayout } from './WebAccountLayout'

export * from './types'

export const AccountLayout: React.FunctionComponent<AccountLayoutProps> = props => {
    // 使用缓存的设备类型（基于 UserAgent，用于选择登录布局）
    const deviceType = useMemo(() => getDeviceTypeFromCache(), [])
    return deviceType === DevicePreviewEnum.DESKTOP ? <WebAccountLayout {...props} /> : <MobileAccountLayout {...props} />
}
